import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://hxhgtivjkwdqxbgzesar.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh4aGd0aXZqa3dkcXhiZ3plc2FyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4Mjg5NTcsImV4cCI6MjA4ODQwNDk1N30.WSbmQqawpPWch0HNVQ216qXWz3y9edTJ1SOiwxBKSrI'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})